var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-action-btn',{attrs:{"access":_vm.canModifyTableRows(_vm.role),"show-tooltip":!_vm.canModifyTableRows(_vm.role),"top":""},on:{"click":function($event){_vm.canModifyTableRows(_vm.role).allowed && _vm.duplicateRowCB({
    tableId: _vm.scheduleId,
    tableType: _vm.tableType,
    rowId: _vm.rowId,
    projectId: _vm.$route.params.id,
  })}},scopedSlots:_vm._u([{key:"iconWrapper",fn:function(){return [_c('v-icon',{attrs:{"small":"","color":"lightBlack"}},[_vm._v(" mdi-content-copy ")])]},proxy:true}])},[_vm._v(" Duplicate ")])}
var staticRenderFns = []

export { render, staticRenderFns }